<div class="container mt-3 mb-3">
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3>Categorías</h3>
                </div>
                <div class="col-6 text-right">
                    <button class="btn btn-success" (click)="nuevo()"> <i class="fas fa-plus"></i> Crear Nueva Categoría</button>
                </div>

            </div>
        </div>
        <div class="card-body">

            <table class="table table-responsive-md">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Orden</th>
                        <th scope="col">Descripción</th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let item of ds_categorias; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>
                            <div class="btn-group" role="group">
                                <button type="button" class="btn btn-secondary" *ngIf="i == ds_categorias.length -1 " disabled="disabled"><i class="fas fa-minus"></i></button>
                                <button (click)="ordena(i, -1)" type="button" class="btn btn-secondary" *ngIf="i < ds_categorias.length -1 "><i class="fas fa-angle-down"></i></button>
                                <button type="button" class="btn btn-secondary" *ngIf="i == 0" disabled="disabled"><i class="fas fa-minus"></i></button>
                                <button (click)="ordena(i, 1)" type="button" class="btn btn-secondary" *ngIf="i > 0"><i class="fas fa-angle-up" disable="true"></i></button>
                            </div>
                        </td>
                        <td>{{ item.categoria | titlecase }}</td>
                        <td> <button class="btn btn-warning" (click)='editar(i, item)'> <i class="far fa-edit"></i> Editar</button> </td>
                        <td> <button class="btn btn-danger" (click)='eliminar(item)'> <i class="far fa-trash-alt"></i> Eliminar </button> </td>
                    </tr>

                </tbody>
            </table>

        </div>
    </div>

</div>